/**
 * The parts of a wagering notice the footer does not already cover.
 *
 * The footer's Responsible use block already says this is informational only, is not
 * betting advice, guarantees nothing, and that Kova neither accepts nor places wagers.
 * What it does not say is how old you have to be, where to get help, or that Kova has
 * nothing to do with the leagues whose marks it draws. And it sits at the bottom of the
 * page, which is not where someone reads a stake size.
 *
 * Wording is a draft for a lawyer to look over, not a substitute for one.
 */

/** Sits directly under a recommended play, next to the stake rather than a scroll away. */
export function BettingDisclaimer() {
  return (
    <p className="border-t border-line px-4 py-3 text-[11px] leading-relaxed text-faint">
      Analysis, not advice. Kova's own testing shows its recommended plays have not beaten
      the market, so treat a stake here as a worked example rather than a reason to risk
      money. 21+ where required, 18+ elsewhere. If gambling stops being fun, call
      1-800-GAMBLER.
    </p>
  );
}

/** Age, help, and the fact that no league endorses this. Goes in the footer. */
export function AffiliationNotice() {
  return (
    <p className="text-[12px] leading-relaxed text-paper/80">
      21+ where required, 18+ elsewhere. Help with problem gambling: 1-800-GAMBLER.
      Kova is an independent project, not affiliated with or endorsed by the NFL, the
      NCAA, ESPN, or any team, conference or sportsbook. Team names, logos and marks
      belong to their owners and appear only to identify the teams being discussed.
    </p>
  );
}
